import UserAdminService from '../../services/UserAdminService';
import SiteAdminService from '../../services/SiteAdminService';

// TYPES
const SET_USERS_DATA = 'SET_USERS_DATA';
const CLEAR_USERS_DATA = 'CLEAR_USERS_DATA';

const SET_SELECTED_USER = 'SET_SELECTED_USER';
const CLEAR_SELECTED_USER = 'CLEAR_SELECTED_USER';

const SET_SITES_DATA = 'SET_SITES_DATA';
const CLEAR_SITES_DATA = 'CLEAR_SITES_DATA';

const SET_ROLES_DATA = 'SET_ROLES_DATA';
const CLEAR_ROLES_DATA = 'CLEAR_ROLES_DATA';

const SET_VESSELS_DATA = 'SET_VESSELS_DATA';
const CLEAR_VESSELS_DATA = 'CLEAR_VESSELS_DATA';

const SET_NOTIFICATION_DATA = 'SET_NOTIFICATION_DATA';
const CLEAR_NOTIFICATION_DATA = 'CLEAR_NOTIFICATION_DATA';

// STATE
const state = {
  usersData: {},
  selectedUser: {},
  allRoles: [],
  allSites: [],
  allVessels: [],
  allNotifications: [],
};

// MUTATIONS
const mutations = {
  [SET_USERS_DATA](state, usersData) {
    state.usersData = usersData;
  },
  [CLEAR_USERS_DATA](state) {
    state.usersData = {};
  },
  [SET_SELECTED_USER](state, userData) {
    state.selectedUser = userData;
  },
  [CLEAR_SELECTED_USER](state) {
    state.selectedUser = {};
  },
  [SET_SITES_DATA](state, allSitesData) {
    state.allSites = allSitesData;
  },
  [CLEAR_SITES_DATA](state) {
    state.allSites = {};
  },
  [SET_ROLES_DATA](state, roles) {
    state.allRoles = roles;
  },
  [CLEAR_ROLES_DATA](state) {
    state.allRoles = [];
  },
  [SET_VESSELS_DATA](state, allVesselsData) {
    state.allVessels = allVesselsData;
  },
  [CLEAR_VESSELS_DATA](state) {
    state.allVessels = {};
  },
  [SET_NOTIFICATION_DATA](state, allNotificationData) {
    state.allNotifications = allNotificationData;
  },
  [CLEAR_NOTIFICATION_DATA](state) {
    state.allNotifications = {};
  },
};

const handleServiceError = (error) => {
  if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    console.log(error.request);
  } else {
    console.log('Error', error.message);
  }
  console.log(error.config);
};

// ACTIONS
const actions = ({
  loadUsers({ commit }, usersFilter) {
    return UserAdminService.getUsers(usersFilter)
      .then((x) => x.data)
      .then((usersData) => {
        commit(SET_USERS_DATA, usersData);
      });
  },
  loadAssignableRoles({ commit }) {
    return UserAdminService.getAssignableRoles()
      .then((x) => x.data.roles)
      .then((roles) => {
        commit(SET_ROLES_DATA, roles);
      });
  },
  loadAssignableSites({ commit }, sitesFilter) {
    return SiteAdminService.getSites(sitesFilter)
      .then((x) => x.data)
      .then((sitesData) => {
        commit(SET_SITES_DATA, sitesData.sites);
      });
  },
  loadAssignableVessels({ commit }, vesselsFilter) {
    return SiteAdminService.getVessels(vesselsFilter)
      .then((x) => x.data)
      .then((vesselsData) => {
        commit(SET_VESSELS_DATA, vesselsData.vessels);
      });
  },
  loadAssignableNotifications({ commit }) {
    return UserAdminService.getAvailableNotifications()
      .then((x) => x.data)
      .then((notificationData) => {
        commit(SET_NOTIFICATION_DATA, notificationData);
      });
  },
  clearUsers({ commit }) {
    commit(CLEAR_USERS_DATA);
  },
  setSelectedUser({ commit }, selectedUser) {
    commit(SET_SELECTED_USER, selectedUser);
  },
  clearSelectedUser({ commit }) {
    commit(CLEAR_SELECTED_USER);
  },
  assignRoleToUser({ commit, dispatch }, { userId, role }) {
    return UserAdminService.assignRoleToUser({ userId, role })
      .then((x) => x.data)
      .then((userData) => {
        commit(SET_SELECTED_USER, userData.user);
        dispatch('loadUsers');
      });
  },
  removeRoleFromUser({ commit, dispatch }, { userId, role }) {
    return UserAdminService.removeRoleFromUser({ userId, role })
      .then((x) => x.data)
      .then((userData) => {
        commit(SET_SELECTED_USER, userData.user);
        dispatch('loadUsers');
      });
  },
  assignSiteToUser({ commit, dispatch }, { userId, site }) {
    return UserAdminService.assignSiteToUser({ userId, site })
      .then((x) => x.data)
      .then((userData) => {
        commit(SET_SELECTED_USER, userData.user);
        dispatch('loadUsers');
      });
  },
  removeSiteFromUser({ commit, dispatch }, { userId, site }) {
    return UserAdminService.removeSiteFromUser({ userId, site })
      .then((x) => x.data)
      .then((userData) => {
        commit(SET_SELECTED_USER, userData.user);
        dispatch('loadUsers');
      });
  },
  assignVesselToUser({ commit, dispatch }, { userId, vessel }) {
    return UserAdminService.assignVesselToUser({ userId, vessel })
      .then((x) => x.data)
      .then((userData) => {
        commit(SET_SELECTED_USER, userData.user);
        dispatch('loadUsers');
      });
  },
  removeVesselFromUser({ commit, dispatch }, { userId, vessel }) {
    return UserAdminService.removeVesselFromUser({ userId, vessel })
      .then((x) => x.data)
      .then((userData) => {
        commit(SET_SELECTED_USER, userData.user);
        dispatch('loadUsers');
      });
  },
  assignNotificationToUser({ commit, dispatch }, assignedNotification) {
    return UserAdminService.assignNotificationToUser(assignedNotification)
      .then((x) => x.data)
      .then((userData) => {
        commit(SET_SELECTED_USER, userData.user);
        dispatch('loadUsers');
      });
  },
  removeNotificationFromUser({ commit, dispatch }, notification) {
    return UserAdminService.removeNotificationFromUser(notification)
      .then((x) => x.data)
      .then((userData) => {
        commit(SET_SELECTED_USER, userData.user);
        dispatch('loadUsers');
      });
  },
  deleteUser({ commit, dispatch }, { userId }) {
    return UserAdminService.deleteUser({ userId })
      .then((x) => x.data)
      .then((userData) => {
        dispatch('clearSelectedUser');
        dispatch('loadUsers');
      });
  },
  disableUserUpdate({ commit, dispatch }, payload) {
    const { userId, disabledBool } = payload;
    return UserAdminService.disableUserUpdate(userId, disabledBool)
      .then((x) => x.data)
      .then((userData) => {
        commit(SET_SELECTED_USER, userData.user);
        dispatch('loadUsers');
      });
  },
  resetUserPassword({ commit, dispatch }, { userId, newPassword }) {
    return UserAdminService.resetUserPassword({ userId, newPassword })
      .then((x) => x.data)
      .then((response) => response)
      .catch(handleServiceError);
  },
  createUser({ commit, dispatch }, { userName, userEmail, userPassword }) {
    return UserAdminService.createUser({ userName, userEmail, userPassword })
      .then((x) => x.data)
      .then((userData) => {
        dispatch('loadUsers');
      })
      .catch(handleServiceError);
  },
});

export default {
  namespaced: true, // Name-space actions, getters and mutations (state always namespaced)
  state,
  mutations,
  actions,
};
